import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { NQRecord } from "@visonum/network-quality-sdk";
import { getSdk } from "../../networkQuality";
import { AppThunk, RootState } from "../../store";
import { reportNQError } from "../errors/errorSlice";
import * as R from "ramda";

export interface HistoryState {
  records: NQRecord[],
}

const initialState: HistoryState = {
  records: [],
}

export const initHistory = (): AppThunk => (dispatch, getState) => {
  getSdk().history().subscribe({
    next: (value) => {
      dispatch(updateRecords(value));
    },
    error: (err) => {
      dispatch(reportNQError(err));
    }
  });
};

export const deleteAllRecords = (): AppThunk => (dispatch, getState) => {
  getSdk().historyDeleteAll();
}

export const deleteRecordBySpeedtestId = (speedtestId: string): AppThunk => (dispatch, getState) => {
  getSdk().historyDeleteRecord(speedtestId);
}


export const historySlice = createSlice({
  name: 'history',
  initialState: initialState,
  reducers: {
    updateRecords: (state, action: PayloadAction<NQRecord[]>) => {
      state.records = action.payload;
    },
  }
});

export const reducer = historySlice.reducer;
const { updateRecords } = historySlice.actions;
export const selectLatestRecord = (state: RootState) => 
  R.head(
    R.sort(
      (a,b) => b.date.getTime() - a.date.getTime(), 
      state[historySlice.name].records
    )
  );